<template>
  <div class="px-2">
    <div class="widget-12 card card-default widget-loader-circle shade mb-4">
      <div class="card-body">
        <div class="row">
          <div id="daftar-topik" class="col-md-4 col-sm-12">
            <div class="m-b-20">
              <h4 class="m-b-0">
                Daftar Topik
                <div class="pull-right" align="right">
                  <div class="form-check form-check-inline switch">
                    <input type="checkbox" v-model="show_grafik_pie" id="pagesSwitchTopik" />
                    <label for="pagesSwitchTopik">Tampilkan Grafik</label>
                  </div>
                </div>
              </h4>
              <p class="small hint-text">Daftar Topik Sentimen</p>
            </div>
            <div class="clearfix" />
            <loader-component v-if="stats === null" />
            <div v-else>
              <div v-if="table_body.length == 0" class="alert alert-danger" id="errorApiEl" role="alert" align="center">
                <strong>Mohon maaf, data tidak tersedia! </strong>
                <br />
                Tidak dapat menampilkan grafik dengan data kosong.
              </div>
              <div v-else>
                <table-dynamic-component v-if="!show_grafik_pie" :data_head="table_head"
                  :data_head_class="data_head_class" :data_body="table_body" table_id="topics-list-table"
                  :config="table_config" />
                <pie-chart-component v-else :data="data_pie" :config="config_pie" :height="420" />
              </div>
            </div>
          </div>
          <div id="tren-topik" class="col-md-8 col-sm-12">
            <div class="pull-left" style="margin-bottom: 0.6rem">
              <h4 class="m-b-0">Grafik Data Tren Berdasarkan Topik</h4>
              <p class="small hint-text">Grafik Data Tren Berdasarkan Topik</p>
            </div>
            <div class="pull-right m-t-20">
              <div class="form-check form-check-inline switch">
                <input type="checkbox" id="show-bar-topik" v-model="show_bar_topik" />
                <label for="show-bar-topik">Tampilkan Grafik Bar</label>
              </div>
            </div>
            <div class="clearfix" />
            <loader-component v-if="data_chart === null" />
            <div v-else-if="Object.keys(data_chart).length === 0" class="alert alert-danger" id="errorApiEl" role="alert"
              align="center">
              <strong>Mohon maaf, data tidak tersedia! </strong>
              <br />
              Tidak dapat menampilkan grafik dengan data kosong.
            </div>
            <div v-else>
              <line-chart-component v-if="!show_bar_topik" :series="data_chart" el="linechart-mention-per-topik"
                mode="single" :height="450" />
              <div v-else>
                <bar-chart-component :data="data_chart" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import line_chart from "@/views/components/chart/line_chart.vue";
import loader_component from "@/views/components/loader.vue";
import bar_chart_horizontal from "@/views/components/chart/bar_chart_horizontal.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";

export default {
  name: "tren_by_topik",
  components: {
    "line-chart-component": line_chart,
    "loader-component": loader_component,
    "bar-chart-component": bar_chart_horizontal,
    "table-dynamic-component": table_dynamic,
    "pie-chart-component": pie_chart,
  },
  props: {
    data: Object,
    stats: null,
  },
  data() {
    return {
      topik: this.stats,
      data_chart: this.data,
      show_bar_topik: false,
      data_pie: [],
      show_grafik_pie: false,
      table_head: ["Topik", "Positif", "Netral", "Negatif", "Total"],
      data_head_class: [
        {
          head: "Positif",
          class: "text-center",
        },
        {
          head: "Netral",
          class: "text-center",
        },
        {
          head: "Negatif",
          class: "text-center",
        },
        {
          head: "Total",
          class: "text-center",
        },
      ],
      table_body: [],
      table_config: {
        lengthMenu: [
          [5, 10, 25, 50, -1],
          [5, 10, 25, 50, "All"],
        ],
        language: {
          search: "Cari :",
          zeroRecords: "Data tidak tersedia",
          info: "Menampilkan halaman _PAGE_ dari _PAGES_",
          infoEmpty: "Menampilkan 0 data",
          lengthMenu: "Tampilkan _MENU_ data",
        },
        pageLength: 5,
      },
      config_pie: {
        align: "center",
        width: 300,
        itemWidth: 150,
      },
    };
  },
  methods: {
    assembleTable: function () {
      let table_body = [];
      if (this.topik.length != 0) {
        for (var i = 0; i < this.topik.topics.length; i++) {
          table_body.push([
            this.topik.topics[i].nama,
            `<center>${this.topik.positif[i]}</center>`,
            `<center>${this.topik.netral[i]}</center>`,
            `<center>${this.topik.negatif[i]}</center>`,
            `<center>${this.topik.total[i]}</center>`,
          ]);
          this.data_pie.push({
            name: this.topik.topics[i].nama,
            y: this.topik.total[i],
            topic_selected: this.topik.topics[i].id,
          });
        }
      }
      this.table_body = table_body;
    },
  },
  created: function () {
    if (this.stats != null) {
      this.assembleTable();
    }
  },
};
</script>